import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { INDUSTRIES } from "@/data/products";

export function IndustriesSection() {
  return (
    <section
      className="bg-vortex-alt py-24 relative overflow-hidden"
      data-testid="industries-section"
    >
      <div className="absolute inset-0 dot-pattern opacity-70 pointer-events-none" />
      <div className="container-wide relative">
        <div className="max-w-2xl mb-14 text-center mx-auto">
          <div className="section-label mb-4">Industries Served</div>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-vortex-navy tracking-tighter leading-[1.05]">
            Trusted across 25+ industries, nationwide.
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {INDUSTRIES.map((ind, i) => {
            const Icon = Icons[ind.icon] || Icons.Building;
            return (
              <motion.div
                key={ind.name}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: i * 0.05, duration: 0.5 }}
                className="group bg-white border border-vortex-border rounded-2xl p-6 hover:border-vortex-blue hover:shadow-lg hover:-translate-y-1 transition-all"
                data-testid={`industry-${i}`}
              >
                <div className="w-12 h-12 rounded-xl bg-vortex-alt group-hover:bg-vortex-navy flex items-center justify-center mb-4 transition-colors">
                  <Icon
                    className="w-5 h-5 text-vortex-blue group-hover:text-vortex-blue"
                    strokeWidth={1.5}
                  />
                </div>
                <div className="font-heading font-bold text-vortex-navy text-[15px] leading-tight">
                  {ind.name}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
